import * as React from "react"
import FormControl from "@material-ui/core/FormControl/FormControl"
import InputLabel from "@material-ui/core/InputLabel/InputLabel"
import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import {Theme, WithStyles, Input, Chip} from "@material-ui/core"
import createStyles from "@material-ui/core/styles/createStyles"
import withStyles from "@material-ui/core/styles/withStyles"
import {compose} from "redux"
import autobind from "autobind-decorator"
import { IFilterItem } from "./filterHelpers";

const styles = (t:Theme) => createStyles({
  select: {
    minWidth: 200
  },
  root: {
    margin: `0 ${t.spacing.unit}px`
  },
  chips: {
      display: 'flex',
      flexWrap: 'wrap',
  },
  chip: {
      margin: t.spacing.unit / 4,
  }
});


interface IProps extends WithStyles<typeof styles>{
  display: string;
  filterBy: string;
  items: IFilterItem[];
  onValueChange?: any;
  selectedDefault?: IFilterItem | IFilterItem[];
}


interface IState {
    items: any;
    mapItem: Map<any, any>;
    typesSelected: any;
}


class DatatableFilterMultipleCustomArray extends React.Component<IProps, IState>{

    state = {
      items: this.props.items,
      mapItem: this.buildMapFilterItem(),
      typesSelected: [],
    };

    @autobind
    private buildMapFilterItem() {
      const mapItem = new Map();
      this.props.items.map(i => {
        mapItem.set(i.value, i.label)
      })
      return mapItem;
    }

    componentDidMount(){
      const {selectedDefault} = this.props;
      if(selectedDefault){
        if(Array.isArray(selectedDefault)){
          this.setState({ typesSelected: selectedDefault.map(x => x.value).join() });
        } else {
          this.setState({ typesSelected: [selectedDefault.value] });
        }
      }
    }
  
    handleChange = (e) => {
        this.setState({ typesSelected: e.target.value });
        this.props.onValueChange(this.props.filterBy, e.target.value.join())
    };
    
  
    render(){
      const { display, classes } = this.props;
      const {items, typesSelected} = this.state
      return (
        <FormControl className={classes.root}>
          {display && <InputLabel>{display}</InputLabel>}
          <Select
            multiple
            value={typesSelected}
            onChange={this.handleChange}
            className={classes.select}
            input={<Input id="select-multiple-chip" />}
            renderValue={this.renderValue}
            fullWidth={true}
          >
            {items.map((i: IFilterItem) => (
              <MenuItem key={`filter-${i.value}`} value={i.value}>{i.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }

    @autobind
    private renderValue(selected: any){
        const {classes} = this.props
        const {mapItem} = this.state
        return (
        <div className={classes.chips}>
            {selected.map(value => (
                <Chip key={value} label={mapItem.get(value) !== undefined ? mapItem.get(value) : '-'} className={classes.chip} />
            ))}
        </div> 
        )
    }
  }
  
export default compose(
  withStyles(styles)
)(DatatableFilterMultipleCustomArray);



// WEBPACK FOOTER //
// ./src/shared/Datatable/Filters/DatatableFilterMultipleCustomArray.tsx